export default {

  view(state) { return state.view },
  creatorId(state) { return state.creatorId },
  creatorName(state) { return state.creatorName },
  date(state) { return state.date },
  time(state) { return state.time },
  location(state) { return state.location },
  allGuests(state) { return state.allGuests },
  nominationType(state) { return state.nominationType },
  allNominations(state) { return state.allNominations },
  voteStatus(state) { return state.voteStatus },
  
};